import { Link } from "react-router-dom";
import { Linkedin, Youtube } from "lucide-react";
import { IseiLogo } from "@/components/IseiLogo";

const footerLinks = [
  { label: "About", href: "/about" },
  { label: "Research", href: "/articles" },
  { label: "Work", href: "/work" },
  { label: "Dashboard", href: "/dashboard" },
  { label: "RHTP", href: "/rhtp" },
  { label: "Field Notes", href: "/field-notes" },
  { label: "Corrections", href: "/corrections" },
  { label: "Media", href: "/media" },
  { label: "Speaking", href: "/speaking" },
  { label: "Press", href: "/press-kit" },
  { label: "Contact", href: "/connect" },
];

const Footer = () => {
  return (
    <footer className="border-t border-border/30 bg-card/50" role="contentinfo">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand + Roles + Cultural note */}
          <div className="md:col-span-2">
            <Link to="/" className="font-display text-xl font-bold text-foreground tracking-tight flex items-center gap-2.5">
              <IseiLogo size={24} />
              David Isei
            </Link>

            <p className="mt-5 text-[12px] text-accent/90 font-medium">
              Executive Director, Hawaiʻi Healthcare Task Force · CEO, Mohala Health · Principal, ISEI Consulting LLC
            </p>

            <p className="mt-3 text-[12px] text-muted-foreground">
              © 2026 David Isei
            </p>

            <p className="mt-6 text-[12px] italic text-muted-foreground/80 leading-relaxed max-w-xl">
              This site operates with respect for the principles of kuleana, mālama ʻāina, and lōkahi.
            </p>

            <div className="mt-6 space-y-1.5">
              <p className="text-[12px] text-muted-foreground">
                Task Force matters:{" "}
                <a
                  href="mailto:david.isei@hawaiihealthcaretaskforce.org"
                  className="text-accent hover:text-accent/80 transition-colors font-medium"
                >
                  david.isei@hawaiihealthcaretaskforce.org
                </a>
              </p>
              <p className="text-[12px] text-muted-foreground">
                Everything else:{" "}
                <a
                  href="mailto:davidisei@iseiconsultingllc.com"
                  className="text-accent hover:text-accent/80 transition-colors font-medium"
                >
                  davidisei@iseiconsultingllc.com
                </a>
              </p>
            </div>

            <div className="flex items-center gap-4 mt-5">
              <a
                href="https://www.linkedin.com/in/david-isei/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="David Isei on LinkedIn"
                className="inline-flex items-center gap-1.5 text-[12px] text-muted-foreground hover:text-accent transition-colors"
              >
                <Linkedin className="h-3.5 w-3.5" />
                LinkedIn
              </a>
              <a
                href="https://www.youtube.com/@ISEIInsights"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="ISEI Insights on YouTube"
                className="inline-flex items-center gap-1.5 text-[12px] text-muted-foreground hover:text-accent transition-colors"
              >
                <Youtube className="h-3.5 w-3.5" />
                YouTube
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground/60 font-semibold mb-4">
              Site
            </p>
            <nav className="flex flex-col gap-2">
              {footerLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.href}
                  className="text-[13px] text-muted-foreground hover:text-foreground transition-colors"
                >
                  {link.label}
                </Link>
              ))}
              <Link to="/privacy" className="text-[13px] text-muted-foreground hover:text-foreground transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-[13px] text-muted-foreground hover:text-foreground transition-colors">
                Terms of Use
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
